export default __webpack_public_path__ + "static/media/Ras_El_Bar.d2a24a06.jpg";